import { render } from "./AddBioLink.vue?vue&type=template&id=19fbe006&scoped=true"
import script from "./AddBioLink.vue?vue&type=script&lang=js"
export * from "./AddBioLink.vue?vue&type=script&lang=js"

import "./AddBioLink.vue?vue&type=style&index=0&id=19fbe006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fbe006"]])

export default __exports__